// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/Modal.css - UPDATED WITH LIGHT THEME */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6); /* Slightly lighter overlay */
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--bg-primary) !important; /* White background */
  padding: 1.8rem 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  position: relative;
  border: 1px solid var(--border-primary); /* Light gray border */
  box-shadow: var(--shadow-xl); /* Standard shadow */
  color: var(--text-primary); /* Dark text */
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-secondary); /* Medium gray */
  cursor: pointer;
  transition: color 0.2s ease;
}
.modal-close:hover {
  color: var(--text-primary); /* Darker gray on hover */
}

.modal-content h2 {
  color: var(--text-primary); /* Dark text for titles */
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.user-details-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.8rem 1.2rem;
  margin-top: 1.5rem;
  font-size: 0.95rem;
}

.user-details-grid strong {
  color: var(--text-primary); /* Dark text */
  font-weight: 600;
}

.user-details-grid span {
    color: var(--text-secondary); /* Medium gray text */
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.8rem;
  padding-top: 1.2rem;
  border-top: 1px solid var(--border-primary); /* Light gray border */
}

/* --- Use existing button styles from Auth.css/App.css --- */
.modal-actions .action-button {
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: var(--border-radius-full); /* Use full radius */
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-button.danger {
    background: var(--error-color); /* Red background */
    color: white;
}
.action-button.danger:hover {
    background: #B91C1C; /* Darker red from App.css equivalent */
    transform: scale(1.05); /* Similar hover */
    box-shadow: var(--shadow-lg);
}

.action-button.success {
    background: var(--success-color); /* Green background */
    color: white;
}
.action-button.success:hover {
    background: #047857; /* Darker green from App.css equivalent */
    transform: scale(1.05);
    box-shadow: var(--shadow-lg);
}

/* Make sure error messages use light theme variables */
.modal-content .error-message {
    background: var(--error-bg-light);
    color: var(--error-color);
    border: 1px solid var(--border-accent);
}
.modal-content.large {
  max-width: 800px; /* Wider for resumes */
  max-height: 90vh; /* Taller */
  display: flex;
  flex-direction: column;
}

.resume-preview-content {
  flex-grow: 1; /* Allows the content to fill the space */
  overflow-y: auto; /* Adds a scrollbar if content is too long */
  background: #F9FAFB; /* Light gray background */
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg);
  padding: 1.5rem;
  line-height: 1.6;
}

/* Basic styling for the converted HTML */
.resume-preview-content h1,
.resume-preview-content h2,
.resume-preview-content h3 {
  color: var(--text-primary);
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.resume-preview-content p {
  color: var(--text-secondary);
  margin-bottom: 0.75rem;
}
.resume-preview-content ul,
.resume-preview-content ol {
  padding-left: 2rem;
  margin-bottom: 1rem;
}
.resume-preview-content li {
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.modal-content.large {
  max-width: 800px; /* Wider for resumes */
  max-height: 90vh; /* Taller */
  display: flex;
  flex-direction: column;
}

.resume-preview-content {
  flex-grow: 1; /* Allows the content to fill the space */
  overflow-y: auto; /* Adds a scrollbar if content is too long */
  background: #F9FAFB; /* Light gray background */
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg);
  padding: 1.5rem;
  line-height: 1.6;
}

/* Basic styling for the converted HTML */
.resume-preview-content h1,
.resume-preview-content h2,
.resume-preview-content h3 {
  color: var(--text-primary);
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.resume-preview-content p {
  color: var(--text-secondary);
  margin-bottom: 0.75rem;
}
.resume-preview-content ul,
.resume-preview-content ol {
  padding-left: 2rem;
  margin-bottom: 1rem;
}
.resume-preview-content li {
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

/* --- Make sure this rule is in your Modal.css file for the 'Close' button --- */
.modal-actions .submit-button.secondary {
  background: transparent !important;
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  box-shadow: none;
}
.modal-actions .submit-button.secondary:hover:not(:disabled) {
  background: var(--bg-secondary) !important;
  border-color: var(--text-secondary);
  box-shadow: var(--shadow-lg);
  transform: scale(1.03);
}`, "",{"version":3,"sources":["webpack://./src/styles/Modal.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B,EAAE,6BAA6B;EAC7D,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,8CAA8C,EAAE,qBAAqB;EACrE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC,EAAE,sBAAsB;EAC/D,4BAA4B,EAAE,oBAAoB;EAClD,0BAA0B,EAAE,cAAc;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B,EAAE,gBAAgB;EAC9C,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,0BAA0B,EAAE,yBAAyB;AACvD;;AAEA;EACE,0BAA0B,EAAE,yBAAyB;EACrD,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB;AAClB;;AAEA;IACI,4BAA4B,EAAE,qBAAqB;AACvD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C,EAAE,sBAAsB;AACrE;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC,EAAE,oBAAoB;EAC9D,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;IACI,8BAA8B,EAAE,mBAAmB;IACnD,YAAY;AAChB;AACA;IACI,mBAAmB,EAAE,uCAAuC;IAC5D,sBAAsB,EAAE,kBAAkB;IAC1C,4BAA4B;AAChC;;AAEA;IACI,gCAAgC,EAAE,qBAAqB;IACvD,YAAY;AAChB;AACA;IACI,mBAAmB,EAAE,yCAAyC;IAC9D,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA,uDAAuD;AACvD;IACI,iCAAiC;IACjC,yBAAyB;IACzB,sCAAsC;AAC1C;AACA;EACE,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB,EAAE,WAAW;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,yCAAyC;EACvD,gBAAgB,EAAE,4CAA4C;EAC9D,mBAAmB,EAAE,0BAA0B;EAC/C,uCAAuC;EACvC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;EAGE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB,EAAE,WAAW;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,yCAAyC;EACvD,gBAAgB,EAAE,4CAA4C;EAC9D,mBAAmB,EAAE,0BAA0B;EAC/C,uCAAuC;EACvC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;EAGE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,4BAA4B;EAC5B,sBAAsB;AACxB","sourcesContent":["/* frontend/src/styles/Modal.css - UPDATED WITH LIGHT THEME */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6); /* Slightly lighter overlay */\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: var(--bg-primary) !important; /* White background */\n  padding: 1.8rem 2rem;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  position: relative;\n  border: 1px solid var(--border-primary); /* Light gray border */\n  box-shadow: var(--shadow-xl); /* Standard shadow */\n  color: var(--text-primary); /* Dark text */\n}\n\n.modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--text-secondary); /* Medium gray */\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n.modal-close:hover {\n  color: var(--text-primary); /* Darker gray on hover */\n}\n\n.modal-content h2 {\n  color: var(--text-primary); /* Dark text for titles */\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.user-details-grid {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem 1.2rem;\n  margin-top: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.user-details-grid strong {\n  color: var(--text-primary); /* Dark text */\n  font-weight: 600;\n}\n\n.user-details-grid span {\n    color: var(--text-secondary); /* Medium gray text */\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.8rem;\n  padding-top: 1.2rem;\n  border-top: 1px solid var(--border-primary); /* Light gray border */\n}\n\n/* --- Use existing button styles from Auth.css/App.css --- */\n.modal-actions .action-button {\n  padding: 0.6rem 1.2rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: var(--border-radius-full); /* Use full radius */\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.action-button.danger {\n    background: var(--error-color); /* Red background */\n    color: white;\n}\n.action-button.danger:hover {\n    background: #B91C1C; /* Darker red from App.css equivalent */\n    transform: scale(1.05); /* Similar hover */\n    box-shadow: var(--shadow-lg);\n}\n\n.action-button.success {\n    background: var(--success-color); /* Green background */\n    color: white;\n}\n.action-button.success:hover {\n    background: #047857; /* Darker green from App.css equivalent */\n    transform: scale(1.05);\n    box-shadow: var(--shadow-lg);\n}\n\n/* Make sure error messages use light theme variables */\n.modal-content .error-message {\n    background: var(--error-bg-light);\n    color: var(--error-color);\n    border: 1px solid var(--border-accent);\n}\n.modal-content.large {\n  max-width: 800px; /* Wider for resumes */\n  max-height: 90vh; /* Taller */\n  display: flex;\n  flex-direction: column;\n}\n\n.resume-preview-content {\n  flex-grow: 1; /* Allows the content to fill the space */\n  overflow-y: auto; /* Adds a scrollbar if content is too long */\n  background: #F9FAFB; /* Light gray background */\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 1.5rem;\n  line-height: 1.6;\n}\n\n/* Basic styling for the converted HTML */\n.resume-preview-content h1,\n.resume-preview-content h2,\n.resume-preview-content h3 {\n  color: var(--text-primary);\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n.resume-preview-content p {\n  color: var(--text-secondary);\n  margin-bottom: 0.75rem;\n}\n.resume-preview-content ul,\n.resume-preview-content ol {\n  padding-left: 2rem;\n  margin-bottom: 1rem;\n}\n.resume-preview-content li {\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.modal-content.large {\n  max-width: 800px; /* Wider for resumes */\n  max-height: 90vh; /* Taller */\n  display: flex;\n  flex-direction: column;\n}\n\n.resume-preview-content {\n  flex-grow: 1; /* Allows the content to fill the space */\n  overflow-y: auto; /* Adds a scrollbar if content is too long */\n  background: #F9FAFB; /* Light gray background */\n  border: 1px solid var(--border-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 1.5rem;\n  line-height: 1.6;\n}\n\n/* Basic styling for the converted HTML */\n.resume-preview-content h1,\n.resume-preview-content h2,\n.resume-preview-content h3 {\n  color: var(--text-primary);\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n.resume-preview-content p {\n  color: var(--text-secondary);\n  margin-bottom: 0.75rem;\n}\n.resume-preview-content ul,\n.resume-preview-content ol {\n  padding-left: 2rem;\n  margin-bottom: 1rem;\n}\n.resume-preview-content li {\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n/* --- Make sure this rule is in your Modal.css file for the 'Close' button --- */\n.modal-actions .submit-button.secondary {\n  background: transparent !important;\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  box-shadow: none;\n}\n.modal-actions .submit-button.secondary:hover:not(:disabled) {\n  background: var(--bg-secondary) !important;\n  border-color: var(--text-secondary);\n  box-shadow: var(--shadow-lg);\n  transform: scale(1.03);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
